// extracted by mini-css-extract-plugin
export default {"divSection":"DetailBlog_divSection__h4+uq"};